<template>
  <div>
    <ed-email :intContaEmailId="$route.params.intId" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdEmail from "@/components/configuracoes/contaEmail/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdEmail },
  mounted() {
    if(!this.$route.params.intId){
      this.$router.push({ name: "configuracoes.contaEmail.register" });
    }
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>